import { create } from 'zustand';

/**
 * Live read pointers for the currently-open conversations.
 *
 * High-water-mark model, mirroring the server: for each context we keep, per user,
 * the id + timestamp of the furthest message they've read. The UI derives everything
 * from that — DM "Seen" (did the other person's pointer reach my last message) and
 * group reader avatars (whose pointer sits on this message).
 */
const useReadReceiptStore = create((set) => ({
  channelReads: {}, // channelId -> { userId -> { messageId, at } }
  dmReads: {},      // dmId      -> { userId -> { messageId, at } }

  /** Seed a channel from GET /channels/:id/read-state. */
  setChannelReads: (channelId, rows) =>
    set((state) => {
      const map = {};
      for (const r of rows) {
        if (r.lastReadMessageId) {
          map[r.userId] = { messageId: r.lastReadMessageId, at: r.lastReadAt };
        }
      }
      return { channelReads: { ...state.channelReads, [channelId]: map } };
    }),

  /** Apply one live read_receipt:update. */
  setChannelRead: (channelId, userId, messageId, at) =>
    set((state) => ({
      channelReads: {
        ...state.channelReads,
        [channelId]: {
          ...(state.channelReads[channelId] || {}),
          [userId]: { messageId, at },
        },
      },
    })),

  /** Seed a DM from GET /dm/:id/read-state. */
  setDmReads: (dmId, rows) =>
    set((state) => {
      const map = {};
      for (const r of rows) {
        if (r.lastReadMessageId) {
          map[r.userId] = { messageId: r.lastReadMessageId, at: r.lastReadAt };
        }
      }
      return { dmReads: { ...state.dmReads, [dmId]: map } };
    }),

  /** Apply one live dm:read. */
  setDmRead: (dmId, userId, messageId, at) =>
    set((state) => ({
      dmReads: {
        ...state.dmReads,
        [dmId]: {
          ...(state.dmReads[dmId] || {}),
          [userId]: { messageId, at },
        },
      },
    })),
}));

export default useReadReceiptStore;
